import type { SxProps, Theme } from "@mui/material";
import { FORM_INPUT_FONT_SIZE } from "@constants/brand.colors";
import {
	formFieldPlaceholderColor,
	formFieldSelectedColor,
	formMenuItem,
	selectControlSx,
} from "@config/theme/formControls";

export {
	selectControlSx,
	selectOutlinedInputSx,
	outlinedInputExternalLabelProps,
	selectChevronCapClassName,
	mergeSelectSx,
	defaultSelectMenuProps,
} from "@config/theme/formControls";

export const menuPaperSx: SxProps<Theme> = {
	borderRadius: 2,
	boxShadow: "0 2px 8px 0 rgba(16, 24, 40, 0.04)",
	mt: 1,
};

export const menuZIndexSx = {
	zIndex: 10001,
};

export const menuItemSx = (isPlaceholder: boolean): SxProps<Theme> => ({
	...(isPlaceholder && {
		color: "#98A2B3",
		fontStyle: "normal",
		fontFamily: "Poppins, sans-serif",
		fontSize: "12px",
		fontWeight: "400",
		"&.Mui-disabled": {
			color: "#98A2B3 !important",
			backgroundColor: "transparent !important",
		},
	}),
	...(!isPlaceholder && {
		fontFamily: "Poppins, sans-serif",
		fontSize: "12px",
		fontWeight: "400",
		"&:hover": {
			backgroundColor: formMenuItem.hoverBg,
			color: formMenuItem.hoverColor,
		},
		"&.Mui-selected": {
			backgroundColor: formMenuItem.selectedBg,
			color: formMenuItem.selectedColor,
			borderRadius: 1,
		},
		"&.Mui-selected:hover": {
			backgroundColor: formMenuItem.selectedHoverBg,
			color: formMenuItem.selectedColor,
		},
		"&.Mui-focusVisible": {
			backgroundColor: formMenuItem.hoverBg,
			color: formMenuItem.hoverColor,
		},
	}),
});

export const selectRenderValuePlaceholderSx: SxProps<Theme> = {
	color: formFieldPlaceholderColor,
	fontStyle: "normal",
	fontSize: FORM_INPUT_FONT_SIZE,
	fontFamily: "Poppins, sans-serif",
	fontWeight: "400",
};

export const selectRenderValueSelectedSx: SxProps<Theme> = {
	color: formFieldSelectedColor,
	fontFamily: "Poppins, sans-serif",
	fontSize: FORM_INPUT_FONT_SIZE,
	fontWeight: "400",
};

export const menuItemContentSx: SxProps<Theme> = {
	display: "flex",
	alignItems: "center",
	width: "100%",
};

export const menuItemLabelSx: SxProps<Theme> = {
	flex: 1,
	fontFamily: "Poppins, sans-serif",
	fontSize: "12px",
	fontWeight: "400",
};

export const listItemIconSx: SxProps<Theme> = {
	color: "#fff",
};

export const checkIconSx: SxProps<Theme> = {
	marginLeft: "auto",
};

export const selectSx = selectControlSx;
